// extracted by mini-css-extract-plugin
export var container = "_4l-0";
export var infoButton = "_4l-1";
export var label = "_4l-3";
export var labelExpanded = "_4l-4";
export var price = "_4l-5";
export var priceExpanded = "_4l-6";
export var title = "_4l-2";